export default {
  cannotGetChild: `属性{{name}}から子要素「{{childName}}」を取得できません`,
  cannotImportFilesExceedingQuota: '記録ファイルをインポートできません：ファイルストレージの容量上限を超えます',
  cannotInsertFileExceedingQuota: 'ファイルを追加できません：ファイルストレージの容量上限を超えます',
  cannotOverridePublishedTaxa: '公開済みの分類群を上書きできません',
  cantUpdateStep: `ステップを更新できません`,
  chainCannotBeSaved: '処理チェーンが無効なため保存できません',
  csv: {
    emptyHeaderFound: '列{{columnPosition}}に空のヘッダーが見つかりました',
    emptyHeaders: '空のヘッダーが見つかりました',
  },
  dataExport: {
    excelMaxCellsLimitExceeded:
      'データのエクスポート中にエラーが発生しました（項目数が多すぎます）。CSV形式でのエクスポートをお試しください。',
    noRecordsMatchingSearchCriteria: '検索条件に一致する記録がありません',
  },
  dataImport: {
    importFromMobileNotAllawed: 'Arena Mobileからのデータインポートは許可されていません',
    invalidNodeInRecord:
      '記録「{{recordUuid}}」内のノードが無効です。ノード「{{nodeUuid}}」（ノード定義「{{nodeDefName}}」、uuid「{{nodeDefUuid}}」）：{{details}}',
    noRecordsFound: 'インポートファイルに記録が見つからないか、ファイル形式が正しくありません',
    pendingImportFileNotFoundOrExpired:
      '以前アップロードされたファイルが見つかりません。有効期限が切れた可能性があります。再度アップロードしてください。',
    recordMergeWithSameKeysNotAllowed:
      '記録「{{recordKeyValues}}」をインポートできません：同じキーを持つ別の記録が既に存在し、この調査では同じキーを持つ記録の統合が許可されていません',
    recordOwnedByAnotherUser: '記録「{{recordKeyValues}}」は別のユーザーが所有しているため更新できません',
  },
  entryDataNotFound: '入力データが見つかりません：{{entryName}}',
  expression: {
    identifierNotFound: '$t(expression.identifierNotFound)',
    undefinedFunction: '$t(expression.undefinedFunction)',
  },
  functionHasTooFewArguments:
    '関数{{fnName}}には少なくとも{{minArity}}個の引数が必要です（{{numArgs}}個指定されました）',
  functionHasTooManyArguments: '関数{{fnName}}が受け付ける引数は最大{{maxArity}}個です（{{numArgs}}個指定されました）',
  generic: '予期しないエラー：{{text}}',
  geoWhispApiError: 'Whispサービスは現在一時的に利用できません。',
  importingDataIntoWrongCollectSurvey: '誤った調査へのデータインポートです。期待されるURI：{{collectSurveyUri}}',
  invalidType: '無効な型です：{{type}}',
  jobCanceledOrErrorsFound: 'ジョブがキャンセルされたか、エラーが発生しました。トランザクションをロールバックします',
  jobOrphanedOnRestart: 'サーバーの再起動によりジョブが中断されました。もう一度お試しください。',
  paramIsRequired: 'パラメータ{{param}}は必須です',
  unableToFindParent: '{{name}}の親要素が見つかりません',
  unableToFindNode: '名前が{{name}}のノードが見つかりません',
  unableToFindSibling: '名前が{{name}}の兄弟要素が見つかりません',
  undefinedFunction: `未定義の関数「{{fnName}}」、またはパラメータの型が正しくありません`,
  invalidSyntax: '式の構文が無効です',
  networkError: 'サーバーとの通信中にエラーが発生しました',
  record: {
    errorUpdating: '記録の更新中にエラーが発生しました',
    entityNotFound: 'キー「{{keyValues}}」の項目「{{entityName}}」が見つかりません',
    updateSelfAndDependentsDefaultValues:
      '$t(appErrors:record.errorUpdating)。ノード{{nodeDefName}}での式の評価中にエラーが発生しました：{{details}}',
  },
  recordPrintableExport: {
    missingEntityParams: '現在のページのエクスポートにはentityDefUuidとentityNodeUuidが必要です',
    entityNotFound: '指定されたエクスポート対象の項目が見つかりません',
    missingServerUrl: 'QRコード付きエクスポートには公開サーバーURLが必要です',
    qrTokenMismatch: 'QRコードのエクスポートを確定できませんでした。再試行してください',
  },
  sessionExpiredRefreshPage: `セッションの有効期限が切れた可能性があります。
ページを更新してください。`,
  survey: {
    nodeDefNameNotFound: 'ノード定義が見つかりません：{{name}}',
    dataMigrationInProgress: 'この調査はアップグレード中です。しばらくしてから再度お試しください。',
    fileNotFound: 'ファイルが見つかりません',
  },
  unsupportedFunctionType: 'サポートされていない関数の型です：{{exprType}}',
  // AI gateway errors
  aiNotConfigured:
    'AIが設定されていません。AI設定で個人用プロバイダーを設定するか、管理者にデフォルトの設定を依頼してください。',
  aiFeaturesDisabled: 'このデプロイメントではAI機能が無効になっています。',
  aiFeatureDisabled: 'AI機能「{{feature}}」は無効になっています。',
  aiPromptTooLarge: 'AIプロンプトが大きすぎます（{{size}}文字、上限{{limit}}文字）。',
  aiInputTooLong: 'AI入力欄「{{field}}」が{{limit}}文字の上限を超えています。',
  aiSchemaMissing: '機能「{{feature}}」のAI構造化出力スキーマが見つかりません。',
  aiProviderInvalid: 'サポートされていないAIプロバイダーです：{{provider}}。',
  aiModelMissing: 'AIモデルの識別子が必要です。',
  aiApiKeyMissing: 'プロバイダー{{provider}}にはAPIキーが必要です。',
  aiBaseUrlMissing: 'openai-compatibleプロバイダーにはベースURLが必要です。',
  aiModelListFailed: 'プロバイダーからモデル一覧を取得できませんでした：{{message}}',
  aiExpressionDescriptionMissing: '生成したい式の内容を自然な言葉で説明してください。',
  aiExpressionTypeInvalid: '不明な式の種類です：{{expressionType}}。',
  aiExpressionNodeDefMissing: '対象フィールドが指定されていないため式を生成できません。',
  aiExpressionNodeDefNotFound: '対象フィールド（uuid {{nodeDefUuid}}）が見つかりませんでした。',
  aiExpressionExpressionMissing: '空の式は説明できません。',
  aiTranslationSocketMissing: 'WebSocketが接続されていません。しばらく待ってから再度お試しください。',
  aiTranslationSourceLangMissing: '翻訳には元言語の指定が必要です。',
  aiTranslationTargetLangsMissing: '翻訳には少なくとも1つの対象言語の指定が必要です。',
  aiTranslationItemsMissing: '翻訳する項目がありません。',
  aiTranslationTooManyItems: '一度に処理できる項目数（{{limit}}件）を超えています（{{count}}件指定されました）。',
  aiActivityLogSurveyMissing: 'アクティビティログを要約するには調査の指定が必要です。',
  aiChatbotDisabled: 'このデプロイメントではドキュメントチャットボットが無効になっています。',
  aiChatbotUpstreamError:
    'ドキュメントチャットボットは現在一時的に利用できません。しばらくしてから再度お試しください。',
  aiChatbotPayloadTooLarge: '会話が長すぎます。チャットをクリアして、もう少し短い質問をお試しください。',
  aiDataQueryDescriptionMissing: '表示したいデータを自然な言葉で説明してください。',
  aiDataQueryNoEntities: 'この調査にはクエリ可能な項目がありません。',
  aiDataQueryInvalid: 'AIはこのリクエストに対して有効なクエリを生成できませんでした：{{errors}}',
  aiDataQueryEmpty: '先に項目と属性（またはディメンションとメジャー）を選択してください。',
  aiDataQuerySummaryInvalid: 'AIはこのクエリの名前と説明を提案できませんでした。もう一度お試しください。',
  userCannotDeleteHasMessages:
    'このユーザーは削除できません：{{count}}件のメッセージを作成しています。先にメッセージを削除するか、担当を変更してください',
  userCannotDeleteLastSystemAdmin: 'このユーザーは削除できません：最後のシステム管理者です',
  userCannotDeleteOwnsSurveys:
    'このユーザーは削除できません：{{count}}件の調査を所有しています。先に所有権を移譲してください',
  userCannotDeleteSelf: '自分自身のユーザーアカウントは削除できません',
  userEmailInvalid: '招待メールを{{email}}に送信できませんでした。アドレスが正しいか確認してください',
  userHasPendingInvitation: `メールアドレス「{{email}}」のユーザーには既に招待が保留中です。承認されるまでこの調査に招待することはできません`,
  userHasRole: 'このユーザーは既にこの調査で役割を持っています',
  userHasRole_other: 'これらのユーザーは既にこの調査で役割を持っています',
  userInvalid: '無効なユーザーです',
  surveyCompareFileTooLarge:
    '調査ファイルが大きすぎます（最大 {{maxSize}} MB）：データなしで調査をエクスポートしてください。調査の比較にレコードとそのファイルは不要です',
  userIsAdmin: 'このユーザーは既にシステム管理者です',
  userNotAllowedToChangePref: 'このユーザーは設定を変更する権限がありません',
  userNotAuthorized: 'ユーザー{{userName}}には権限がありません',
  userNotFound: 'ユーザーが見つかりません：{{userUuid}}',
  usersBackupImport: {
    invalidFile: 'このファイルは有効なArenaユーザーバックアップではありません',
  },
}
